import { prefetchInfinitePurchaseHistory } from "@/api/purchases";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/_app/purchases")({
  loader: () => {
    prefetchInfinitePurchaseHistory();
  },
});
